export default {
  submit:           'Avançar',
  error_submitting: 'Tivemos um problema ao processar o seu pedido, por favor, tente novamente mais tarde ou entre em contato com a nossa central de atendimento',
};
